import { useEffect } from 'react';
import { getAuth, signInWithCredential, GoogleAuthProvider } from 'firebase/auth';
import config from 'lib/config';
import Cookies from 'js-cookie';
import { onAuthStateChanged } from 'lib/Auth';

export default function useGoogleOneTap(): void {
  const promptSignIn = (): void => {
    const googleAccounts = (google as any).accounts;
    if (typeof googleAccounts !== 'undefined') {
      const auth = getAuth();
      googleAccounts.id.initialize({
        client_id: config.googleOAuthClientId,
        callback: (response: { credential: string }) => {
          signInWithCredential(auth, GoogleAuthProvider.credential(response.credential));
        },
        auto_select: true,
        context: 'use',
        use_fedcm_for_prompt: true,
      });
      googleAccounts.id.prompt();
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged((firebaseUser) => {
      const hasBeenPrompted = Cookies.get('has_been_prompted');
      if (
        !firebaseUser &&
        !hasBeenPrompted &&
        typeof google !== 'undefined' &&
        typeof window !== 'undefined'
      ) {
        promptSignIn();
      }
    });

    return unsubscribe;
  });
}
